<template>
  <div id="main_obrigado">
    <div class="menu-bar"></div>
    <div class="session-wrapper fade-in-up body-thanks w-100">
      <div class="container container-full-width">

        <div class="row">
          <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
            <div class="thankyou-wrap">
              <div class="card text-white border-rad shadow-md border-0">
                <img class="card-img img-fluid" src="https://mysociety.s3.amazonaws.com/midia-galary/img/thankyou.png"
                  alt="Card image" width="600" height="300" />
                <div class="card-img-overlay border-rad mb-3">
                  <div class="text-center ty-card-title">
                    <h4 class="fw-200 text-white"> Maravilha {{ nome }}, recebemos a solicitação!</h4>
                    <h6 class="text-white mt-4">Por favor, aguarde.</h6>
                  </div>
                </div>
              </div>
              <div class="
                  card
                  border-0 border-rad
                  card-shadow
                  p-4
                  text-center
                  w-65
                  mx-auto
                  card-hover
                ">
                <h6 class="mb-4">
                  <strong>CPV Educacional</strong> para você nas Mídias Sociais
                </h6>
                <div class="social-without-bg mb-4">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a href="https://www.instagram.com/cpveducacional" alt="instagram" v-b-tooltip.hover="'Instagram CPV Educacional'"><i class="fab fa-square-instagram fa-2xl"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="http://www.facebook.com/cpveducacional" alt="facebook" v-b-tooltip.hover="'Facebook CPV Educacional'"><i class="fab fa-square-facebook fa-2xl"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="https://x.com/cpveducacional" alt="twitter" v-b-tooltip.hover="'Twitter CPV Educacional'"><i class="fab fa-square-x-twitter fa-2xl"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="https://br.linkedin.com/company/cpv-grupo-educacional" alt="linkedin" v-b-tooltip.hover="'Linkedin CPV Educacional'"><i class="fab fa-linkedin fa-2xl"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="https://www.youtube.com/cpvgrupoeducacional" alt="youtube" v-b-tooltip.hover="'Youtube CPV Educacional'"><i class="fab fa-square-youtube fa-2xl"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: "Obrigado",
  data() {
    return {
      nome: this.$route.params.nome,
    };
  },
};
</script>
<style scoped>
#main_obrigado {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.thankyou-wrap {
  position: relative;
}

.thankyou-wrap .card-img-overlay {
  background-color: rgba(23, 22, 22, 0.5);
}

.fw-200 {
  font-weight: 200;
}

.ty-card-title {
  font-size: 3.5rem;
  left: 0;
  position: absolute;
  right: 0;
  top: 36%;
  color: #fff;
}

.thankyou-wrap .card-hover {
  margin-top: -95px;
  margin-left: auto !important;
  margin-right: auto !important;
  position: inherit;
  left: auto;
  right: auto;
  top: auto;
}

.card-hover {
  left: 0;
  position: absolute;
  right: 0;
  top: 15rem;
}

.w-65 {
  width: 65%;
}

.card-shadow {
  -webkit-box-shadow: 0 3px 10px 2px rgb(0 0 0 / 10%);
  box-shadow: 0 3px 10px 2px rgb(0 0 0 / 10%);
}

.border-rad,
.card-img {
  border-radius: 1rem;
}

.text-center {
  text-align: center !important;
}

.p-4 {
  padding: 1.8rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
  padding: 1.25rem;
}

.social-without-bg ul li a {
  color: #637282;
}

.svg-inline--fa {
  font-size: 30px !important;
}


.menu-bar {
  margin-top: 10%
}

#main_obrigado h2 p {
  color: #fff;
}
</style>